import Alert from "components/ui/Alert/Alert";
import CenterSlide from "pages/Homepage/Slider/CenterSlide";
import LeftSlide from "pages/Homepage/Slider/LeftSlide";
import RightSlide from "pages/Homepage/Slider/RightSlide";
import Loader from "components/ui/Loader/Loader";
import { useEntity } from "hooks/useEntity";
import 'swiper/css';
import 'pages/Homepage/Slider/Slider.scss';
import { ReactComponent as IconSwipe } from "assets/images/icons/swipe.svg";
import { Swiper, SwiperSlide } from "swiper/react";

function Slider() {
  const { entity, isLoading } = useEntity('/', 'frontpage');

  if (isLoading) {
    return <Loader/>
  }

  if (!isLoading && !entity) {
    return <Alert/>;
  }

  return (
    <Swiper
      slidesPerView={ 1.04 }
      spaceBetween={ 16 }
      loop={ true }
      resizeObserver={ false }
      breakpoints={ {
        768: {
          slidesPerView: 2,
          initialSlide: 1,
          centeredSlides: true,
          spaceBetween: 32,
        },
      } }
    >
      <SwiperSlide>
        <LeftSlide content={ entity }/>
      </SwiperSlide>

      <SwiperSlide>
        <CenterSlide content={ entity.field_slider_primary_image.value }/>
      </SwiperSlide>

      <SwiperSlide>
        <RightSlide content={ entity }/>
      </SwiperSlide>

      <div className={ 'swiper-icon' }>
        <IconSwipe/>
      </div>
    </Swiper>
  );
}

export default Slider;
